import {
  TRAIL_LATERAL_MOVEMENT_REQ,
  TRAIL_LATERAL_MOVEMENT_REQ_SUCCESS,
  TRAIL_LATERAL_MOVEMENT_REQ_ERROR,
  UNIQ_COMBO_LATERAL_MOVEMENT,
  UNIQ_COMBO_PRIV_LATERAL_MOVEMENT
} from './trailsinfo.type'

import ApiRest from '@/api/api-rest'

const state = {
  lateralMovementReqStatus: '',
  lateralMovements: {},
  uniqComboLateralMovements: {},
  uniqComboPrivLateralMovements: {}
}

const getters = {
  lateralMovementReqStatus: state => state.lateralMovementReqStatus,
  lateralMovements: state => state.lateralMovements,
  uniqComboLateralMovements: state => state.uniqComboLateralMovements,
  uniqComboPrivLateralMovements: state => state.uniqComboPrivLateralMovements
}

// Best Practice - updates state
const mutations = {
  [UNIQ_COMBO_LATERAL_MOVEMENT]: (state, data) => {
    state.uniqComboLateralMovements = data
  },
  [UNIQ_COMBO_PRIV_LATERAL_MOVEMENT]: (state, data) => {
    state.uniqComboPrivLateralMovements = data
  },
  [TRAIL_LATERAL_MOVEMENT_REQ]: state => {
    state.lateralMovementReqStatus = 'loading'
  },
  [TRAIL_LATERAL_MOVEMENT_REQ_SUCCESS]: (state, data) => {
    state.lateralMovementReqStatus = 'saved'
    state.lateralMovements = data
  },
  [TRAIL_LATERAL_MOVEMENT_REQ_ERROR]: (state, errMsg) => {
    state.lateralMovementReqStatus = 'error'
  }
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [TRAIL_LATERAL_MOVEMENT_REQ] (context) {
    return new Promise((resolve, reject) => {
      context.commit(TRAIL_LATERAL_MOVEMENT_REQ)
      ApiRest()
        .get('/trails/trailinfo/lateralmovement')
        // .get('static/json/lateralmovement.json')
        .then(({ data }) => {
          context.commit(TRAIL_LATERAL_MOVEMENT_REQ_SUCCESS, data)
          data.sort((a, b) => {
            return a.seenTime - b.seenTime
          })
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(TRAIL_LATERAL_MOVEMENT_REQ_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [UNIQ_COMBO_LATERAL_MOVEMENT] (context, data) {
    context.commit(UNIQ_COMBO_LATERAL_MOVEMENT, data)
  },
  [UNIQ_COMBO_PRIV_LATERAL_MOVEMENT] (context, data) {
    context.commit(UNIQ_COMBO_PRIV_LATERAL_MOVEMENT, data)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/trails/lateralmovement.module.js